module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Cloud1-ae75ad1e09d49a5fc0974722939700dc.svg";